// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a5789877","105":"af8ab64e","549":"0b70fa42"}[chunkId] + ".chunk.js";
};